"use strict";
/**
 * Determine if a cookie or selected sub is aal.
 * @param sub
 * @returns a boolean
 */
Object.defineProperty(exports, "__esModule", { value: true });
const isAal = (sub) => {
    // If the sub is an object then the test is being done on the selected sub with shape {phoneNumber:'aal'}
    if (typeof sub === 'object')
        return (sub === null || sub === void 0 ? void 0 : sub.phoneNumber) === 'aal' || (sub === null || sub === void 0 ? void 0 : sub.sub) === 'aal';
    // Otherwise the test is being done on a cookie and it is aal if it is an empty string
    return sub === 'aal';
};
exports.default = isAal;
//# sourceMappingURL=isAal.js.map